import api from '../services/api';
import { $Qll, $Q } from '../utils/query-selector';
import { dataToggle, toggleDataActive, toggleAriaBusy } from '../utils/toggle-dataset';
import {
  updateCartItems,
  updateDiagnosticCartItems,
  updatetotalPrice,
  updateRecommended,
  updateUpsell,
  updateCartbutton,
  updatePriceItem,
  updateCartItem,
  updateCartQuantity,
  updateEmptyCart
} from './update-cart';
import { renderQuantityLimit } from '../utils/input-quantity';

import { sliderUpsell } from "./slider-swiper"

import { barProgress, toggleBarProgress, updateBarProgress } from '../utils/bar-progress';
import { checkModalCart } from './modal-cart';

const cart = $Q('.js-cart .cart-wrapper');

const SECTIONS_TO_RENDER = cart.getAttribute('data-section-id');
const MAINPRODUCT_TO_RENDER = 'main-product';

$Qll('.progress-bar__container').forEach((item) => {
  barProgress(item);
});

sliderUpsell()


/**
 * Listen if add to cart form is submited
 * if add to cart form is submited add products in cart
 *
 * @param {string} formQuery - className reference in form add-to-cart
 *
 * To active this feature - ADD className 'add-product-cart' in form product
 * */

//  window.btnAddToCart = (formQuery) => {
//   const addForms = $Qll(formQuery);

//   if (addForms != null) {
//     addForms.forEach((form) => {
//       if (form.dataset.submit === 'true') return;

//       submitForm(form);
//       form.dataset.submit = true;
//     });
//   }
// };

export const btnAddToCart = (formQuery) => {
  const addForms = $Qll(formQuery);

  if (addForms != null) {
    addForms.forEach((form) => {
      form.classList.remove('jc-pointer-events-none');
      if (form.dataset.submit === 'true') return;
      submitForm(form);
      form.dataset.submit = true;
    });
  }
};

window.btnAddToCart = btnAddToCart

const submitForm = async (form) => {
  return form.addEventListener('submit', (e) => {
    e.preventDefault();
    addProducts(e, form);
    checkModalCart();

    if  (e.target.dataset.form != 'upsell' && !e.target.dataset.diagnostic) {
      dataToggle($Q('.js-cart'), true);
    } else if (e.target.dataset.diagnostic && window.innerWidth < 992) {
      dataToggle($Q('.js-cart'), true);
    }
  });
};

/**
 * Add products in cart
 * @param {event} event -Event submit from add to cart form
 * @param {HTMLElement} form - It is the form as a parent
 */
const addProducts = async (event, form) => {

  const sellingPlan = $Q('[name="selling_plan"]:checked', form);
  const quantityInput = $Q('[name="quantity"]', form);
  const modalCart = $Q('.modal-cart');
  const isModalActive = modalCart.dataset && modalCart.dataset.active === "true";
//  const isDiagnostic = form.dataset.diagnostic ? form.dataset.diagnostic : null;

  let itemInCart;

  let inputQuantity = 1;

  if (quantityInput) {
    inputQuantity = quantityInput.value;
  }

  let items = [];

  const subscribeRadioBtn = $Q('#subscribe', isModalActive && modalCart);
  const sellingPlanValue = sellingPlan && sellingPlan.value;
  const sellingPlanCheck = subscribeRadioBtn && subscribeRadioBtn.checked;

  // Add custom gift card properties if applicable
  let properties;
  if (document.querySelector('#Recipient-email')) {
    properties = {
      "Recipient email": document.querySelector('#Recipient-email').value,
      "Message": document.querySelector('#RecipientForm-addMessage').checked ? document.querySelector('#Recipient-message').value : '',
      "Recipient name": document.querySelector('#Recipient-name').value,
      "Sender name": "Anatae store",
      "Send on": "",
      __shopify_offset: "-180",
      __shopify_send_gift_card_to_recipient: "on",
      __selling_plan: sellingPlanCheck ? sellingPlanValue : null
    }
  }

  for (const input of event.target) {
    if (input.name === "id") {
      items.push({ id: input.value, quantity: inputQuantity, selling_plan: sellingPlanCheck ? sellingPlanValue : null, properties: properties ? properties : null })
    }
  }


  const cartParams = {
    items: items,
    sections: [SECTIONS_TO_RENDER, MAINPRODUCT_TO_RENDER],
  };

  const response = await api.addToCart(cartParams);

  if (response && response.status === 422) {
    const description = response.data && response.data.description;
    showErrorMessage(description);
    return;
  } 

  const { sections } = response

  // if (quantityInput) {
  //   quantityInput.value = 1;
  // }
 
  updateEmptyCart(sections[SECTIONS_TO_RENDER]);
  updateCartItems(sections[SECTIONS_TO_RENDER]);
  updateDiagnosticCartItems(sections[SECTIONS_TO_RENDER]);
  updateCartbutton(sections[SECTIONS_TO_RENDER]);
  updatetotalPrice(sections[SECTIONS_TO_RENDER]);
  updateRecommended(sections[MAINPRODUCT_TO_RENDER]);
  updateUpsell(sections[SECTIONS_TO_RENDER]);
  updateCartQuantity(sections[SECTIONS_TO_RENDER]);
  updateBarProgress(sections[SECTIONS_TO_RENDER]);

  document.dispatchEvent(new CustomEvent('update-diagnostic-cart'))

  if (quantityInput) {
    renderQuantityLimit(quantityInput.id);
  }

  await checkGift();
};

/**
 * Set an error message in cart
 * @param {String} description - as an inner text
 */
export const showErrorMessage = (description) => {
  const text = $Qll('.cart__error');

  if (!text) return;

  const defaultText = text[0] && text[0].dataset && text[0].dataset.text;
  const innerText = description || defaultText;

  text.forEach(item => {
    item.innerText = innerText;

    item.classList.add('cart__error--show');

    setTimeout(() => {
      item.classList.remove('cart__error--show');
    }, 5000);
  })
}

/**
 * Event onChange in the cart item
 */

export const onChangeItemCart = () => {
  let debounceTimer;
  $Qll('.item-cart-js input').forEach((input) => {
    input.addEventListener('change', function (e) {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
         updateCart(this.id, this.value, e);
      }, 300);
    });
  });
};

/**
 * Update quantity for each item in cart
 * @param {number} id Product ID
 * @param {number} quantity new quantity
 * @param {event} e - Javascript event
 */
export const getCart = async () => {
  const sectionId = cart.getAttribute('data-section-id');
  const url = `/?sections=${sectionId}`;
  try {
    const response = await fetch(url);
    const data = await response.json();
    const sectionHtml = data[sectionId];
    if (sectionHtml) {
      updateCartItems(sectionHtml);
      updateCartQuantity(sectionHtml);

      // Parse the HTML and re-render the progress bar content
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = sectionHtml;
      const newCartWrapper = tempDiv.querySelector('.progress-bar__container');
      if (newCartWrapper) {
        cart.querySelector('.progress-bar__container').innerHTML = newCartWrapper.innerHTML;
        barProgress();
      }
    }
  } catch (error) {
    console.error('Error fetching section:', error);
    return null;
  }
};

export const updateCart = async (id, quantity, e) => {
  const { target } = e;
  const cartItem = target.closest('.js-cart-item');
  const itemKey = cartItem.dataset.liveItemKey;
  const loading = $Q('.cart-item__loading', target.closest('.js-cart-item'));
  const itemKeyFormatted = itemKey.split('_').join(':');
  const cartParams = {
    id: itemKeyFormatted,
    quantity: quantity,
    sections: [SECTIONS_TO_RENDER, MAINPRODUCT_TO_RENDER],
  }

  toggleAriaBusy(cartItem);
  dataToggle(loading);

  const { sections } = await api.updateCart(cartParams);

  if (quantity == 0) {
    updateCartItems(sections[SECTIONS_TO_RENDER]);
    updateDiagnosticCartItems(sections[SECTIONS_TO_RENDER]);
  } else {
    updatePriceItem(sections[SECTIONS_TO_RENDER], id, itemKey);
    updateCartItem(sections[SECTIONS_TO_RENDER], itemKey);
  }

  updateEmptyCart(sections[SECTIONS_TO_RENDER]);
  updatetotalPrice(sections[SECTIONS_TO_RENDER]);
  updateRecommended(sections[MAINPRODUCT_TO_RENDER]);
  updateUpsell(sections[SECTIONS_TO_RENDER]);
  updateCartbutton(sections[SECTIONS_TO_RENDER]);
  updateCartQuantity(sections[SECTIONS_TO_RENDER]);
  updateBarProgress(sections[SECTIONS_TO_RENDER]);
  toggleAriaBusy(cartItem);
  dataToggle(loading);

  document.dispatchEvent(new CustomEvent('update-diagnostic-cart'));
  renderQuantityLimit(id);

  await checkGift();
};

/**
 * Delete item in cart
 * listen if delete button is clicked
 * if is clicked, update cart with quantity 0
 */
export const deleteItem = () => {
  const deleteIcon = $Qll('.item-delete');

  if (deleteIcon) {
    deleteIcon.forEach((element) => {
      element.addEventListener('click', (e) => {
        updateCart(element.dataset.id, 0, e);
      });
    });
  }
};

/**
 * Open and close side cart with various buttons
 */
export const openCloseCart = () => {
  const cartContainer = $Q('.cart');

  if (!cartContainer) return null;
  cartContainer.setAttribute('data-active', 'false');

  toggleDataActive('.cart-close', '.shopify-section-group-cart-group', {
    overlay: true,
  });

  toggleDataActive('.cart-arrow-close', '.shopify-section-group-cart-group', {
    overlay: true,
  });

  toggleDataActive('.cart-button', '.shopify-section-group-cart-group', {
    overlay: true,
  });
};

export const onLoadEmptyCart = () => {
  if (typeof window === 'undefined') return;
  if (!window.location.pathname.includes('cart')) return;

  window.addEventListener('load', () => {
    const cartPage = $Q('.cart-page');

    if (!cartPage) return;

    const cartWrapper = $Q('.wrapper', cartPage);
    const cartEmptyInfo = $Q('.cart-empty', cartPage);

    if (!cartWrapper || !cartEmptyInfo) return;

    const isCartEmpty = cartWrapper.dataset.empty === 'true' ? true : false;

    if (isCartEmpty) {
      cartEmptyInfo.classList.remove('hidden');
    }
  })
}

/**
 *  This function handles opening side cart from
 *  header icon
 */
export const openCartFromHeader = () => {
  const headerIcon = $Q('.js-cart-button--link');

  if (!headerIcon) return;

  document.addEventListener('DOMContentLoaded', () => {
    headerIcon.classList.remove('jc-pointer-events-none');
  })

  headerIcon.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();

    const header = $Q('.shopify-section-group-cart-group');

    if (!header) return;

    dataToggle(header, true);
    checkEmptySideCart();
  })
}

/**
 *  This function checks if cart is empty when is opened
 *  from header icon
 */
const checkEmptySideCart = () => {
  const cartWrapper = $Q('.cart-wrapper');
  const cartItems = $Q('.cart .cart-wrapper .cartitems-js #cart-items');

  if (!cartWrapper || !cartItems) return;

  if (!Object.values(cartItems.children).length) {
    cartWrapper.classList.add('cart-wrapper--empty');
  }
}

export const checkGift = async () => {
  try {
    console.log('Running checkGift');
    const response = await fetch('/cart.js');
    const data = await response.json();
    
    let itemsToRemove = [];
    
    for (const item of data.items) {
      if (item.properties._gift && item.properties._promocode) {
        const minCartPrice = item.properties._minCartPrice;
        const minCartQuantity = item.properties._minCartQuantity;
        
        // Calculate total price without current gift item
        const totalPriceWithoutGift = data.items
          .filter(cartItem => cartItem.key !== item.key)
          .reduce((sum, cartItem) => sum + (cartItem.final_line_price || cartItem.line_price || 0), 0);
        
        // Calculate total quantity without current gift item
        const totalQuantityWithoutGift = data.items
          .filter(cartItem => cartItem.key !== item.key)
          .reduce((sum, cartItem) => sum + cartItem.quantity, 0);
        
        let shouldRemove = false;

        if (minCartPrice && minCartPrice !== '') {
          const minPrice = parseFloat(minCartPrice) * 100;
          if (!isNaN(minPrice) && totalPriceWithoutGift < minPrice) {
            shouldRemove = true;
          }
        }

        if (minCartQuantity && minCartQuantity !== '') {
          const minQuantity = parseInt(minCartQuantity, 10);
          if (!isNaN(minQuantity) && totalQuantityWithoutGift < minQuantity) {
            shouldRemove = true;
          }
        }
        
        // Collect items to remove
        if (shouldRemove) {
          itemsToRemove.push(item.key);
        }
      }
    }
    
    // Remove all items that don't meet requirements
    if (itemsToRemove.length > 0) {
      for (const itemKey of itemsToRemove) {
        await api.updateCart({
          id: itemKey,
          quantity: 0,
          sections: [SECTIONS_TO_RENDER, MAINPRODUCT_TO_RENDER],
        });
      }
      
      // Fetch updated cart sections and update UI
      const url = `/?sections=${SECTIONS_TO_RENDER},${MAINPRODUCT_TO_RENDER}`;
      const sectionsResponse = await fetch(url);
      const sectionsData = await sectionsResponse.json();
      const sections = sectionsData;

      updateEmptyCart(sections[SECTIONS_TO_RENDER]);
      updateCartItems(sections[SECTIONS_TO_RENDER]);
      updateDiagnosticCartItems(sections[SECTIONS_TO_RENDER]);
      updateCartbutton(sections[SECTIONS_TO_RENDER]);
      updatetotalPrice(sections[SECTIONS_TO_RENDER]);
      updateRecommended(sections[MAINPRODUCT_TO_RENDER]);
      updateUpsell(sections[SECTIONS_TO_RENDER]);
      updateCartQuantity(sections[SECTIONS_TO_RENDER]);
      updateBarProgress(sections[SECTIONS_TO_RENDER]);
      
      document.dispatchEvent(new CustomEvent('update-diagnostic-cart'));
    }
  } catch (error) {
    console.error('Error checking gift items:', error);
    return null;
  }
}